import React from "react";
import styles from "./index.module.scss";
import icon from "./top-rated-icon@3x.svg";
export default class TopRated extends React.Component {
    render() {
        return (React.createElement("img", { src: icon, alt: "Top Rated", className: `${styles.icon} ${this.props.className}` }));
    }
}
